import styled from 'styled-components';

import { BLACK, WHITE, PAGE_WIDTH, BG_GRAY, TEXT_GRAY } from '@/styles/variables.style';
import media from '@/styles/media.style';

export const RecommendedListWrap = styled.div`
  width: 100%;
  max-width: ${PAGE_WIDTH}px;
  margin: 60px auto 30px;
  padding: 0 20px;

  ${media.tabletL`
    margin: 100px auto 60px;
  `};
`;

export const ContentsTitle = styled.h2`
  text-align: center;
  margin-bottom: 30px;
  font-size: 20px;
  line-height: 22px;
  color: ${BLACK};

  ${media.tabletL`
    font-size: 30px;
    line-height: 32px;
    margin-bottom: 70px;
  `};
`;

export const ItemInfomationWrap = styled.div`
  color: ${BLACK};

  ${media.tabletL`
    width: calc(100% - 525px);
    padding-left: 94px;
  `};

  ${media.desktopMedium`
    width: 525px;
  `};
`;

export const ItemListTitle = styled.div`
  font-size: 14px;
  position: relative;
  text-align: center;
  margin: 0 0 40px 0;

  ${media.tabletL`
    font-size: 18px;
    margin:0 0 80px 0;
  `};

  &:after {
    position: absolute;
    left: 50%;
    bottom: -10px;
    transform: translateX(-50%);
    display: block;
    content: '';
    width: 26px;
    height: 1px;
    background: ${BLACK};

    ${media.tabletL`
      width: 40px;
      height: 2px;
      bottom: -15px;
    `};
  }
`;

export const RecommendedItem = styled.div`
  margin-bottom: 40px;

  ${media.tabletL`
    display: flex;
    margin-bottom: 60px;
  `};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ItemImage = styled.div`
  ${media.tabletL`
    width: 525px;
    height: 350px;
  `};

  img {
    max-width: 100%;
  }
`;

export const ItemTitle = styled.div`
  padding-top: 20px;

  ${media.tabletL`
    padding-top: 0;
  `};

  .lead {
    font-size: 14px;
    margin-bottom: 3px;

    ${media.tabletL`
      font-size: 18px;
      line-height: 20px;
    `};
  }
  .title {
    font-size: 18px;
    margin-bottom: 0;

    ${media.tabletL`
      font-size: 24px;
      line-height: 26px;
    `};
  }
`;

export const ItemStatus = styled.div`
  margin-top: 20px;
`;

export const ItemCaption = styled.div`
  margin-top: 20px;
  font-size: 14px;
  line-height: 16px;

  ${media.tabletL`
    font-size: 18px;
    line-height: 20px;
  `};
`;

export const ItemDetailLink = styled.div`
  font-size: 12px;
  margin-top: 25px;
  text-decoration: underline;
`;

export const SubmitCover = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${media.tabletL`
    margin-top: 80px;
  `};

  button {
    width: 366px;
    height: 50px;
    border-radius: 0;
    background-color: ${BLACK};
    color: ${WHITE};
    font-size: 13px;
    border: none;

    ${media.tabletL`
      width: 260px;
      height: 64px;
      font-size: 14px;
    `};
  }

  .ant-btn: hover,
  .ant-btn: focus,
  .ant-btn: active,
  .ant-btn .active {
    text-decoration: none;
    background-color: ${BLACK};
  }
  .ant-btn:hover,
  .ant-btn:focus {
    color: ${WHITE};
    background-color: ${BLACK};
  }
`;

export const PowerContainerWrap = styled.div`
  width: 300px;
  margin: 0 auto;
`;

export const PowerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const PowerTitle = styled.div`
  font-size: 12px;
  color: #000;
  width: 120px;

  ${media.tabletL`
    font-size: 14px;
  `};

  &.small {
    font-size: 12px;
  }
`;

export const PowerValueContainer = styled.div`
  flex: 1;
  flex-grow: 1;
  margin-left: -15px;
  align-items: center;

  .powerbar {
    margin-left: 0px;
    margin-top: 3px;
    margin-bottom: 0;
    display: flex;
  }
  .powerbar li {
    list-style-type: none;
    width: 80%;
    font-size: 5px;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    color: ${TEXT_GRAY.COMMON_4};
  }

  .powerbar li:before {
    width: 10px;
    height: 10px;
    content: '';
    line-height: 10px;
    background-color: ${BG_GRAY.COMMON_7};
    display: block;
    text-align: center;
    margin: 0 auto 0 auto;
    border-radius: 50%;
  }

  .powerbar li:after {
    width: 100%;
    height: 2px;
    content: '';
    position: absolute;
    background-color: ${BG_GRAY.COMMON_7};
    top: 4px;
    left: -50%;
    margin-left: 5px;
  }
  .powerbar li:first-child:after {
    content: none;
  }
  .powerbar li.active {
    color: ${BLACK};
  }
  .powerbar li.active:before {
    background-color: ${BLACK};
  }
  .powerbar li.active:after {
    background-color: ${BLACK};
  }
`;



// WEBPACK FOOTER //
// ./src/pages/HairDiagnosis/HairDiagnosisResultPage/SalonMenuResult/SalonMenuResult.style.js